<template>
  <module-page v-bind="pageParams" :customBreadcrumbs="customBreadcrumbs">
    <v-tabs class="page__tabs" hide-slider>
      <v-tab
        :key="i"
        v-for="(incomeReport, i) in incomeReports"
        active-class="financial--background white--text opaque"
        @click="currentIncomeReport = incomeReport || {}"
      >
        <span class="no-print">
          {{ getContractTitle(incomeReport.contract) }}
        </span>
        <span class="print-only">
          <span class="font-weight-bold">{{
            getContractTitle(incomeReport.contract)
          }}</span
          >: {{ selectedUnit.product.title }} - {{ selectedUnit.block.title }} -
          Unidade {{ selectedUnit.unit.code }}
        </span>
      </v-tab>
    </v-tabs>
    <v-layout align-start justify-space-between row py-3>
      <div v-if="!error" class="financial-ir__description">
        {{ pageParams.texts.description }}
      </div>
      <button
        v-if="!loading && !error"
        @click="print"
        class="financial-ir__print-btn financial--background white--text no-print"
      >
        <i class="bexsicon-printer icon"></i>
      </button>
    </v-layout>
    <screen-loading v-if="loading"></screen-loading>
    <div v-else-if="error" class="empty-state">
      {{ $t('responses.error') }}
    </div>
    <div v-else>
      <v-card class="mt-4 mb-5">
        <v-card-title class="print-only">
          <p v-html="printText" />
        </v-card-title>
        <v-card-text>
          <p v-html="speText" />
          <p v-html="clientText" />

          <v-data-table
            :headers="incomeHeaders"
            :items="currentIncomeReport.income"
            hide-actions
            :no-data-text="pageParams.emptyState.income"
            sort-icon="bexsicon-down"
          >
            <template slot="items" slot-scope="props">
              <td class="text-xs-center">
                {{ props.item.year }}
              </td>
              <td class="text-xs-center">{{ props.item.participation }}%</td>
              <td class="text-xs-center">
                {{ formatMoney(props.item.participationValue) }}
              </td>
              <td class="text-xs-center">
                {{ formatMoney(props.item.value) }}
              </td>
              <td class="text-xs-center">
                {{
                  formatMoney(props.item.financing)
                    ? formatMoney(props.item.financing)
                    : '-'
                }}
              </td>
              <td class="text-xs-center">
                {{
                  formatMoney((props.item.financing || 0) + props.item.value)
                }}
              </td>
            </template>
          </v-data-table>
          <div class="participation_description mt-2">
            *Participação referente ao valor pago com recursos próprios
          </div>
        </v-card-text>
      </v-card>
    </div>
  </module-page>
</template>

<script>
import bus from '@/utils/bus';
import enums from '@/utils/enums';
import ModulePage from '@/components/layout/Page';
import ScreenLoading from '@/components/loaders/ScreenLoading';
import profileMixin from '@/mixins/modules/profile';
import { APP, USER, UNIT } from '@/utils/constants';
import logTrace from '@/services/logTrace';
import moment from 'moment';

export default {
  name: 'financial-income-report',
  mixins: [profileMixin],
  components: {
    ModulePage,
    ScreenLoading,
  },
  computed: {
    customBreadcrumbs() {
      const { title } = this.pageParams;
      const text = `${title}: ${this.getContractTitle(this.selectedContract)}`;
      return [{ text }];
    },
    incomeHeaders: function () {
      const width = !this.mobile ? '16%' : undefined;
      return [
        { text: 'Ano', value: 'year', align: 'center', width },
        {
          text: 'Participação',
          value: 'participation',
          align: 'center',
          width,
        },
        {
          text: 'Valor Participação*',
          value: 'participationValue',
          align: 'center',
          width,
        },
        {
          text: 'Recursos Próprios',
          value: 'ownResources',
          align: 'center',
          width,
        },
        {
          text: 'Financiamento',
          value: 'financing',
          align: 'center',
          width,
        },
        { text: 'Valor Total', value: 'value', align: 'center', width },
      ];
    },
    speText() {
      const product = this.$store.getters[UNIT.GET_SELECTED_PRODUCT];
      return `<b>Empresa</b>: ${
        product.nameSPE
      } &emsp; &emsp; <b>CNPJ</b>: ${this.formatDocument(product.cnpjSPE)}`;
    },
    clientText() {
      const user = this.$store.getters[USER.GET_USER];
      return `<b>Cliente</b>: ${
        user.fullName
      } &emsp; &emsp; <b>CPF/CNPJ</b>: ${this.formatDocument(user.username)}`;
    },
    printText() {
      return `<b>Data Impressão</b>: ${moment().format('DD/MM/YYYY HH:mm')}`;
    },
    income() {
      return this.currentIncomeReport && this.currentIncomeReport.income
        ? this.currentIncomeReport.income
        : [];
    },
  },
  data() {
    return {
      pageParams: this.$store.getters[APP.PAGES].financialIR,
      error: false,
      loading: false,
      selectedContract: '',
      selectedContractIndex: 0,
      activeStatus: 'Ativo',
      currentIncomeReport: {},
      incomeReports: [],
    };
  },
  created() {
    bus.$on('unit:change', this.getFirstActiveContractIR);
    bus.$on('unit:update', this.getFirstActiveContractIR);

    this.getIR(0);

    this.currentIncomeReport = this.incomeReports[0] || {};
  },
  beforeDestroy() {
    bus.$off('unit:change', this.getFirstActiveContractIR);
    bus.$off('unit:update', this.getFirstActiveContractIR);
  },
  methods: {
    async getFirstActiveContractIR(unitObj = null) {
      this.getIR();
    },
    cleanDoc(v) {
      return v.replace(/\./g, '').replace('-', '');
    },
    async getIR(contractIndex = null) {
      try {
        if (!contractIndex) {
          contractIndex = this.selectedUnit.contracts.findIndex(
            (o) => o.isValid
          );
        }

        const contract = this.selectedUnit.contracts[contractIndex];

        if (this.selectedContract.id === contract.id) return;

        this.loading = true;
        this.error = false;

        this.selectedContract = contract;
        this.selectedContractIndex = contractIndex;

        const params = {
          contractId: contract.id,
          unitId: this.selectedUnit.unit.id,
          userId: this.user.username,
        };

        const tracePath = this.enums.logTraceActionRoutes['incomeReport'];
        if (tracePath)
          logTrace({ action: tracePath, contractId: this.selectedContract.id });

        const result = await this.requestService(
          process.env.IR_API_URL,
          'GET',
          {
            params,
            localErrorHandling: true,
          }
        );

        if (result && result.length) {
          this.incomeReports = result;
          this.currentIncomeReport = this.incomeReports[0];
        } else {
          this.incomeReports = [];
          this.currentIncomeReport = {};
        }
      } catch (err) {
        console.log('error', err);
        this.error = true;
      } finally {
        this.loading = false;
      }
    },
    print() {
      this.createTrace(
        this.enums.logTraceActions.financialIRPrint,
        {},
        this.selectedContract.id
      );
      window.print();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/breakpoint';

.financial-ir {
  &__print-btn {
    flex: 0.05;
    min-width: 40px;
    max-height: 28px;
    border-radius: 5px;
    padding: 5px;
  }
  &__description {
    flex: 0.93;
    padding: 0;
    color: var(--label-color);
    font-size: 1em;
    text-align: justify;
  }
  &__btn {
    background-color: var(--financial-color) !important;
    color: #fff;
    position: relative;
    right: 1em;
    width: 40px;
    padding: 0.2em 0.8em;
    border-top-left-radius: 5px !important;
    border-top-right-radius: 5px !important;
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;
    text-align: center;
    height: 25px;
    margin-left: 10%;
  }
}

.participation_description {
  font-size: 0.7em;
}
</style>



// WEBPACK FOOTER //
// src/views/financial/IncomeReport.vue